<template>
  <v-container fluid class="pb-0">
    <v-row class="time_period_wrap justify-end mb-0 align-center rounded-t">
      <v-col v-if="isDisplayTimer" cols="12" lg="10">
        <slot name="timePeriod"></slot>
      </v-col>
      <v-col cols="10" lg="2">
        <v-text-field
            @input="debounceSearch"
            prepend-inner-icon="mdi-magnify"
            :label="placeholder"
            dark
            single-line
            hide-details
            class="pt-0 mt-0"
        ></v-text-field>
      </v-col>
      <v-col cols="1" lg="1" v-if="isDisplaySettings" style="max-width: 80px">
        <Settings :headers="headers" :headerType="headerType"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {debounce} from "debounce";
import Settings from "./Settings"
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Search'
    },
    headers: {
      type: Array,
      default: ()=>[]
    },
    headerType: {
      type: String,
      default: ''
    },
    isDisplaySettings: {
      type: Boolean,
      default: false
    },
    isDisplayTimer : {
        type: Boolean,
        default: false
    }
  },
  components: {
      Settings
  },
  name: "DataTableTopBar",
  methods: {
    debounceSearch: debounce(function (value) {
      this.$emit('search', value)
    }, 700),
  },
  mounted() {}
}
</script>

<style scoped>

</style>
